import { colors } from "../../../../common/styles";

export const listItemButtonStyle = (isSelected, theme, level) => ({
    backgroundColor: isSelected ? "rgba(0, 0, 0, 0.04)" : "transparent",
    py: 0.25,
    pl: level * 2,
    "& .MuiTypography-root": {
        fontWeight: isSelected ? "bold" : "normal",
        color: isSelected ? theme.palette.primary.main : "inherit"
    }
});

export default {
    mainHeaderContainer: {
        "& > p": { float: "left" },
        "& > button": { float: "right" }
    },
    list: {
        width: "100%",
        "& .MuiListItemIcon-root": {
            minWidth: "25px"
        }
    },
    subList: {
        paddingRight: 2
    },
    listItem: {
        maxHeight: "20px",
        padding: "0 8px",

        "& div > span": {
            textTransform: "capitalize"
        }
    },
    auditorList: { maxHeight: "20vh", overflow: "scroll", clear: "both" },
    auditorContainer: {
        "&  .MuiDataGrid-root": { height: "50vh" }
    },
    hideFont: {
        fontSize: 0,
        "& svg": {
            color: "inherit"
        },
        "& .MuiBadge-root .MuiBadge-badge": {
            margin: "6px 0"
        }
    },
    selectContainer: {
        maxWidth: 256,
        minWidth: 256
    },
    primaryButton: {
        backgroundColor: colors.blue,
        color: colors.white,
        borderRadius: 32,
        px: 2,
        py: 1,
        ":hover": {
            backgroundColor: colors.blue,
            color: colors.white
        }
    },
    secondaryButton: {
        backgroundColor: colors.mediumGrey,
        color: colors.black,
        borderRadius: 32,
        px: 2,
        py: 1,
        ":hover": {
            backgroundColor: colors.blue,
            color: colors.white
        }
    },
    auditorListContainer: {
        width: "100%",
        margin: 2,
        "& li": {
            width: "30%",
            display: "inline-block",
            " & .MuiListItemButton-root": {
                "& .MuiListItemIcon-root": {
                    minWidth: "25px"
                },
                " & .MuiTypography-body2": {
                    fontSize: "0.75rem"
                }
            }
        }
    },
    signeeCloseButton: {
        position: "absolute",
        right: 8,
        top: 8,
        color: "black"
        // color: theme.palette.grey[500]
    },
    auditorActionContainer: {
        textAlign: "right",
        "& > button": {
            margin: 1
        }
    },
    dealerSectionContainer: {
        display: "flex",
        flexWrap: "wrap",
        " & .MuiCard-root": { width: 250, m: 2, flex: "1 0 21%" },
        "& img": {
            objectFit: "contain",
            cursor: "pointer",
            borderRadius: 1
        },
        "& .MuiTextField-root ": { mb: 1 }
    },
    auditorCardContainer: { display: "flex", flexWrap: "wrap" },
    signatureCardContainer: {
        width: 250,
        m: 2,
        flex: "1 0 21%",
        "& img": { objectFit: "contain" }
    },
    signatureUploadContainer: {
        position: "relative",
        textAlign: "center",
        mt: 1
    },
    editIconButton: {
        position: "absolute",
        bottom: 5,
        right: 5
    },
    editActionButtons: {
        display: "flex",
        justifyContent: "end",
        my: 1,
        "& button": {
            m: 1
        }
    },
    errorText: {
        color: "red",
        fontSize: "0.75rem",
        mt: 1
    },

    auditCommentDialogTitle: {
        m: 0,
        p: 2
    },

    auditCommentCloseButton: (theme) => ({
        position: "absolute",
        right: 8,
        top: 8,
        color: theme.palette.grey[500]
    })
};
